// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1ed_0","file":"styles_file__1VBR3"};